import { useContext } from 'react'
import LoggerContext from './context'
import { Logger } from '.'

const useLogger = (): Logger => useContext(LoggerContext)

export default useLogger
